
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';


function Mumbaitosolapurtaxi() {



    const cardData =
    {
        keyword: 'Mumbai to Solapur Taxi ',
        heading: 'Morya Cabs: Mumbai to Solapur Taxi',
        headingDescription: 'Morya Cabs offers dependable and convenient taxi services from Mumbai to Solapur. Whether you are traveling for business, pilgrimage, or leisure, our well-maintained vehicles and experienced drivers will ensure a smooth and comfortable journey. The distance between Mumbai and Solapur is approximately 350 km, with a travel time of around 6 to 7 hours by road, depending on traffic conditions. Choose Morya Cabs for a safe, comfortable, and affordable ride to Solapur.',

        top: 'Top Places to Visit in Solapur with Morya Cabs',

"topPlaces": [
        {
            "title": "Shirdi Sai Baba Temple",
            "location": "Shirdi, Maharashtra",
            "description": "Shirdi, located near Solapur, is home to the famous Sai Baba Temple, one of the most visited pilgrimage sites in India. Devotees from all over the country visit to pay respects and seek blessings from Sai Baba. The temple’s peaceful and spiritual atmosphere makes it a must-visit destination for religious travelers."
        },
        {
            "title": "Solapur Fort",
            "location": "Solapur, Maharashtra",
            "description": "Solapur Fort, located in the heart of the city, is a historic landmark that holds great significance. It was built during the Maratha period and is known for its impressive architecture and strategic location. The fort offers stunning views of the city and provides a glimpse into Solapur’s rich history."
        },
        {
            "title": "Pandharpur Vithoba Temple",
            "location": "Pandharpur, Maharashtra",
            "description": "Another important pilgrimage site near Solapur, the Vithoba Temple in Pandharpur is dedicated to Lord Vithoba (a form of Lord Krishna). The temple is known for its religious importance and attracts thousands of devotees, especially during the famous Ashadhi Ekadashi festival."
        },
        {
            "title": "Ujani Dam",
            "location": "Solapur, Maharashtra",
            "description": "Located around 30 km from Solapur, Ujani Dam is a serene and picturesque spot. The dam is a popular destination for nature lovers and offers boating opportunities, as well as a chance to enjoy the tranquil atmosphere and scenic views."
        },
        {
            "title": "Akkalkot Swaminarayan Temple",
            "location": "Akkalkot, Maharashtra",
            "description": "Akkalkot, located near Solapur, is known for its Swaminarayan Temple, which is dedicated to Lord Swaminarayan. The temple attracts many devotees who come to seek blessings and enjoy the peaceful environment."
        },
        {
            "title": "Barsi",
            "location": "Barsi, Maharashtra",
            "description": "Barsi is a small town near Solapur, known for its religious and cultural significance. It has temples and historical sites that make it a great place for spiritual and cultural exploration."
        },
        {
            "title": "Naldurg Fort",
            "location": "Naldurg, Maharashtra",
            "description": "Naldurg Fort is located about 75 km from Solapur and is a significant historical fort built during the Maratha period. The fort offers panoramic views of the surrounding countryside and is an interesting site for history enthusiasts."
        },
        {
            "title": "Tembhurni",
            "location": "Tembhurni, Maharashtra",
            "description": "Tembhurni is a small village near Solapur known for its tranquil environment and beautiful landscapes. It is an ideal location for those looking to escape the hustle and bustle of the city and spend time in a peaceful setting."
        },
        {
            "title": "Tuljapur Temple",
            "location": "Tuljapur, Maharashtra",
            "description": "Located 45 km from Solapur, the Tuljapur Temple is one of the 51 Shakti Peethas and is dedicated to Goddess Tulja Bhavani. It is a major pilgrimage destination and attracts thousands of visitors throughout the year."
        },
        {
            "title": "Bhuikot Fort",
            "location": "Solapur, Maharashtra",
            "description": "Bhuikot Fort, located in the heart of Solapur city, is an ancient fort built during the reign of the Nizam Shahi dynasty. The fort offers a glimpse into the region’s history and provides a scenic view of the surrounding area."
        }
    ],


"services": [
    {
        "name": "Mumbai to Solapur Taxi",
        "description": "If you're planning a trip from Mumbai to Solapur, Morya Cab offers reliable and comfortable taxi services. Whether you’re traveling for business, leisure, or any special occasion, our taxis are equipped to provide a smooth and safe journey. You can count on our experienced drivers to take you to Solapur efficiently and comfortably."
    },
    {
        "name": "Mumbai to Solapur Cab Service",
        "description": "Morya Cab provides an excellent cab service for your journey from Mumbai to Solapur. With a variety of vehicle options such as Innova, Ertiga, and sedan taxis, you can choose a vehicle that suits your comfort and group size. Our experienced drivers ensure a pleasant and safe ride, and we guarantee prompt service with no delays."
    },
    {
        "name": "Mumbai to Solapur Taxi Fare",
        "description": "Morya Cab offers competitive pricing for taxi rides from Mumbai to Solapur. The fare is affordable and varies based on the type of vehicle and the duration of your journey. We provide transparent pricing with no hidden charges, so you can rest assured you are getting the best deal for your trip. For an accurate quote, feel free to contact us."
    },
    {
        "name": "Mumbai to Solapur One Way Taxi",
        "description": "If you need a one-way taxi from Mumbai to Solapur, Morya Cab is your perfect choice. We provide flexible one-way taxi services that ensure a hassle-free ride with no return commitment. This is perfect for passengers who want to avoid long drives or for those who need a taxi just for the onward journey."
    },
    {
        "name": "Taxi from Mumbai to Solapur",
        "description": "Our taxi services from Mumbai to Solapur ensure a quick and easy trip. Our drivers are familiar with the best routes, ensuring a smooth ride with minimal delays. Whether you're heading for business meetings or leisure travel, we provide a reliable taxi service to Solapur that meets your expectations."
    },
    {
        "name": "Mumbai to Solapur Innova",
        "description": "For group travelers or those seeking a more spacious and comfortable ride, Morya Cab offers Innova taxis from Mumbai to Solapur. The Innova is an ideal choice for families or groups who prefer extra comfort during long trips. With ample space and great features, your journey will be a pleasurable experience."
    },
    {
        "name": "Mumbai to Solapur Ertiga",
        "description": "If you need a comfortable yet affordable vehicle for your journey from Mumbai to Solapur, the Ertiga is a great choice. With enough seating for small groups and extra luggage space, it’s an ideal vehicle for a comfortable ride. Morya Cab offers Ertiga taxis at competitive prices for your convenience."
    },
    {
        "name": "Mumbai to Solapur Sedan",
        "description": "For a compact and economical option, our sedan taxis from Mumbai to Solapur are an excellent choice. These vehicles offer comfort and efficiency for solo travelers or small groups. Our sedan taxis come with air conditioning and all the necessary features for a smooth ride."
    },
    {
        "name": "Mumbai to Solapur Car Hire",
        "description": "Morya Cab offers car hire services for your journey from Mumbai to Solapur. If you prefer to travel at your own pace or need a vehicle for an extended period, we provide well-maintained cars for hire. Choose from a variety of vehicles, and enjoy a personalized travel experience."
    },
    {
        "name": "Mumbai to Solapur by Cab",
        "description": "Whether you're traveling for business, attending an event, or enjoying a holiday, our cab services from Mumbai to Solapur are a perfect choice. We ensure a safe and hassle-free ride with top-notch customer service and excellent vehicles. Our professional drivers ensure that your journey is comfortable from start to finish."
    },
    {
        "name": "Solapur Trip from Mumbai",
        "description": "Morya Cab offers the best taxi service for a trip from Mumbai to Solapur. The journey from Mumbai to Solapur takes you through scenic landscapes, and with our taxis, you can enjoy the trip in complete comfort. Our drivers are knowledgeable about the best routes to ensure you get to Solapur in the most efficient way possible."
    },
    {
        "name": "Mumbai to Solapur Drop Taxi",
        "description": "For passengers looking for a one-way drop, Morya Cab offers a convenient drop taxi service from Mumbai to Solapur. Simply book your ride, and our professional driver will pick you up from your preferred location and take you directly to Solapur. This service is available 24/7 for your convenience."
    },
    {
        "name": "Mumbai to Solapur Round Trip",
        "description": "If you’re planning a round trip from Mumbai to Solapur, Morya Cab offers round trip taxi services that cater to your needs. We provide flexible options for pick-up and return, so you can plan your trip with ease. Our round-trip service ensures that you are dropped off at your destination and picked up when you're ready to return."
    },
    {
        "name": "Solapur Taxi Booking from Mumbai",
        "description": "Booking your taxi from Mumbai to Solapur is easy with Morya Cab. You can book online, by phone, or via our mobile app for your convenience. We offer 24/7 booking options, so you can reserve a taxi at any time. Our team will ensure that your taxi is ready and on time for your trip."
    },
    {
        "name": "Affordable Taxi Mumbai to Solapur",
        "description": "At Morya Cab, we offer affordable taxi services from Mumbai to Solapur without compromising on quality. Whether you're traveling for business, leisure, or with family, our taxi service is budget-friendly and offers great value for your money. Get in touch with us today for the most competitive rates."
    }
],


tableData: [
    ["Mumbai to Solapur Taxi", "-Mumbai to Solapur Cab Service"],
    ["Mumbai to Solapur Taxi Fare", "-Mumbai to Solapur One Way Taxi"],
    ["Taxi from Mumbai to Solapur", "-Mumbai to Solapur Innova"],
    ["Mumbai to Solapur Ertiga", "-Mumbai to Solapur Sedan"],
    ["Mumbai to Solapur Car Hire", "-Mumbai to Solapur by Cab"],
    ["Solapur Trip from Mumbai", "-Mumbai to Solapur Drop Taxi"],
    ["Mumbai to Solapur Round Trip", "-Solapur Taxi Booking from Mumbai"],
    ["Affordable Taxi Mumbai to Solapur", ""]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "Morya Cab ensures punctual pickups and timely drop-offs for your journey from Mumbai to Solapur. Our drivers are committed to providing you with a smooth and on-time experience, whether you’re traveling for business, leisure, or other commitments."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet of vehicles offers comfort and space, designed to make your long journey from Mumbai to Solapur enjoyable. With spacious interiors, air conditioning, and comfortable seating, we ensure you travel in comfort every step of the way."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained and experienced in handling long-distance journeys. They are knowledgeable about the best routes from Mumbai to Solapur and will ensure your trip is safe, efficient, and hassle-free."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive pricing for your Mumbai to Solapur taxi ride. Our pricing model is transparent, with no hidden charges, so you’ll know exactly what to expect, ensuring you get the best value for your money."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are regularly serviced and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols, so you can have peace of mind throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "We offer round-the-clock service for your convenience. Whether you're planning an early morning departure or a late-night journey, Morya Cab is always available to help you with your Mumbai to Solapur travel needs."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your Mumbai to Solapur taxi is quick and easy. You can book online through our website or mobile app, or you can contact our customer service team for assistance in making your reservation."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "We offer customized travel packages to suit your specific needs. Whether you need to make additional stops or prefer a specific route, let us know, and we’ll tailor your trip accordingly."
    }
]
















    }

    const faqData = [
        {
          question: "How can I book a Mumbai to Solapur taxi with Morya Cab?",
          answer: "You can easily book a taxi via our website or mobile app. Alternatively, you can call our customer service team for personalized assistance with your booking."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, our drivers are experienced in handling long-distance routes like Mumbai to Solapur. They ensure your journey is smooth, safe, and efficient."
        },
        {
          question: "What types of vehicles are available for Mumbai to Solapur travel?",
          answer: "We offer a variety of vehicles including sedans, SUVs, and premium cars, all designed for comfort and long-distance travel."
        },
        {
          question: "How do I pay for my Mumbai to Solapur taxi rental?",
          answer: "We accept multiple payment methods, including cash, credit/debit cards, and online payments through our app, for your convenience."
        },
        {
          question: "Can I book a round trip from Mumbai to Solapur?",
          answer: "Yes, we offer round-trip services. Simply provide your return details when booking, and we’ll arrange everything for you."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "If there are any extra charges for waiting time or detours, they will be communicated to you upfront, ensuring complete transparency in pricing."
        },
        {
          question: "Can I hire a taxi for sightseeing in Solapur?",
          answer: "Yes, we can arrange customized sightseeing tours in Solapur after your journey. Explore attractions like the Solapur Fort, Siddheshwar Temple, and more with a trusted driver."
        },
        {
          question: "What is the luggage allowance for a Mumbai to Solapur taxi?",
          answer: "Our vehicles can accommodate standard luggage. If you have more luggage or specific requirements, please inform us during booking, and we’ll make the necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel from Mumbai to Solapur?",
          answer: "Yes, we offer corporate travel services. Whether it’s for meetings, conferences, or business trips, we can provide a customized travel package for your corporate needs."
        },
        {
          question: "Why should I choose Morya Cab for Mumbai to Solapur travel?",
          answer: "Morya Cab offers reliable service, experienced drivers, affordable pricing, and well-maintained vehicles. We guarantee a safe, comfortable, and stress-free journey for all your long-distance travel needs."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Sanjay Patil',
          role: 'Business Traveler',
          review: 'I used Morya Cab for my trip from Mumbai to Solapur, and the experience was excellent. The driver was professional, and the vehicle was very comfortable. I will definitely choose them for my future trips.',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Suman Agarwal',
          role: 'Family Traveler',
          review: 'Our family used Morya Cab for a trip to Solapur, and the service was outstanding. The vehicle was clean and spacious, and the driver was courteous and punctual. Highly recommend their services!',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      







    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


    


    return (
        <div>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #1CA8CB',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitosolapurtaxi;